var path = 'shared/mask/mask.user.tpl.html';
var html = "<div class=\"sbsf-loading-overlay\" ng-show=\"showMask\">\n  <div class=\"sbsf-loading-img {{extraImgCls}}\"></div>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;